//存储
export const setUserId = (userId) => {
  localStorage.setItem("USERID", userId)
}
export const setUserName = (userName) => {
  localStorage.setItem("USERNAME", userName)
}
export const setUserType = (userType) => {
  localStorage.setItem("USERTYPE", userType)
}

//获取
export const getUserId = () => {
  return localStorage.getItem("USERID")
}
export const getUserName = () => {
  return localStorage.getItem("USERNAME")
}
export const getUserType = () => {
  return localStorage.getItem("USERTYPE")
}
export const removeUserId = () => {
  localStorage.removeItem("USERID")
}
export const removeUserName = () => {
  localStorage.removeItem("USERNAME")
}
export const removeUserType = () => {
  localStorage.removeItem("USERTYPE")
}


// WEBPACK FOOTER //
// ./src/utils/userId.js